module.exports = __webpack_public_path__ + "static/media/bg11.e6314864.jpg";